const defaultConfig = {
    color: '#619cfd',
    partnerId: null,
    partnerDomain: '',
    resDomain: '',
    imgDomain: '',
};
const siteConfig = (state = defaultConfig, action) => {
    switch (action.type) {
        case 'value':
            return [...state];

        default:
            return { ...state };
    }
};
export default siteConfig;


// WEBPACK FOOTER //
// ./src/reducers/site-config.js